/** Template editors and viewers fill the screen below the page header, but never shrink under 750px. */
export const TEMPLATE_EDITOR_HEIGHT = "max(750px, calc(100vh - 220px))";
